import { request } from '/@/utils/http/axios';
import { BasicResult } from '/@/api/model/baseModel';
import { ErrorMessageMode } from '/#/axios';

enum Api {
  List = '/menu/list',
  SelectList = '/menu/selectList',
  Save = '/menu/save',
  Delete = '/menu/delete',
  MainMenu = '/auth/menu',
}

interface MenuItem {
  name: string,
  code: string,
}

type MenuResult = BasicResult<MenuItem>;

export const mainMenuList = (params: any, mode: ErrorMessageMode = 'modal') => {
  return request.get<any[]>(
    { 
      url: Api.MainMenu, params 
    },
    {
      errorMessageMode: mode,
    }
  );
};

export const getMenuList = (params: any, mode: ErrorMessageMode = 'modal') => {
  return request.get<any[]>(
    { 
      url: Api.List, params 
    },
    {
      errorMessageMode: mode,
    }
  );
};

export const getMenuSelectList = (params: any, mode: ErrorMessageMode = 'modal') => {
  return request.get<any[]>(
    { 
      url: Api.SelectList, params 
    },
    {
      errorMessageMode: mode,
    }
  );
};

export const saveMenu = (params: MenuItem, mode: ErrorMessageMode = 'modal') => {
  return request.post<MenuResult>(
    {
      url: Api.Save,
      params,
    },
    {
      errorMessageMode: mode,
    },
  );
};

export const deleteMenu = (params: any, mode: ErrorMessageMode = 'modal') => {
  return request.get<any>(
    {
      url: Api.Delete,
      params,
    },
    {
      errorMessageMode: mode,
    },
  );
};
